import { Injectable, signal, WritableSignal } from '@angular/core';
import { firstValueFrom, Observable, catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

export interface FiscalYear {
  label: string;
  id: number;
  year: string;
}

export interface Period {
  label: string;
  id: number;
}

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  private fiscalYears: FiscalYear[] = [];
  private periods: Period[] = [];

  loading: WritableSignal<boolean> = signal(false);
  autoSaveUrls: string[] = [];
  
  getFiscalYears(): FiscalYear[] {
    const fiscalYearsArray: FiscalYear[] = [];

    for (let i = 1; i <= 30; i++) {
      const paddedNumber = i < 10 ? '0' + i : i.toString();
      fiscalYearsArray.push({
        label: `FY${paddedNumber}`,
        id: i,
        year: `20${paddedNumber}`
      });
    }

    return fiscalYearsArray;
  }
  getPeriods(): Period[] {
    const periodsArray: Period[] = [];

    for (let i = 1; i <= 13; i++) {
      const paddedNumber = i < 10 ? '0' + i : i.toString();
      periodsArray.push({
        label: `P${paddedNumber}`,
        id: i
      });
    }

    return periodsArray;
  }

  constructor(private authService: AuthService, private http: HttpClient) {
    this.fiscalYears = this.getFiscalYears();
    this.periods = this.getPeriods();
  }


  getLoading() {
    return this.loading;
  }
  showLoading(url:string = ''): void {
    if(url && url.length>0)
    {
      const i= this.autoSaveUrls.findIndex(f=>url.search(f)!=-1);
      if(i!=-1)
      {
        this.autoSaveUrls.splice(i,1);
        return;
      }
    }
    this.loading.set(true);
  }
  hideLoading(): void {
    this.loading.set(false);
  }

  async getFeatureInfo(featureName: string,): Promise<any> {
    var user = await firstValueFrom(this.authService.fetchAndCacheRoles());
    return user.ConfigsInfo.find((e: { ConfigKey: string; }) => e.ConfigKey === featureName);
  }


  downloadFile(fileName: string, location: string): void {
    this.http.post(`${environment.apiBaseUrl}/document/DownloadFile`, { fileName, location }, { responseType: 'arraybuffer', observe: 'response' })
      .subscribe({
        next: response => {
          const contentDisposition = response.headers.get('Content-Disposition');
          let filename = fileName;
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
              filename = match[1];
            }
          }
          const blob = new Blob([response.body as ArrayBuffer], { type: response.headers.get('Content-Type') || 'application/octet-stream' });
          if ((window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(blob, filename);
          } else {
            // Sanitize filename to prevent DOMXSS before assigning to DOM element
            const safeFilename = String(filename || 'download')
              .replace(/[<>"'`]/g, '')
              .replace(/[^\w\s.\-_()[\]]/g, '')
              .trim() || 'download';
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = safeFilename;
            // Click detached anchor — no appendChild needed in modern browsers
            link.click();
          }
        },
        error: () => {
          // handle error (e.g. show notification)
        }
      });
  }
  get fiscalYearsData(): FiscalYear[] {
    return this.fiscalYears;
  }

  get periodsData(): Period[] {
    return this.periods;
  }

  //  Reset auto-saved data
  resetAutosavedData(resetData: any): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/feedback/resetAutosavedData`, resetData).pipe(
      catchError((error) => {
        console.error('Error resetting auto-saved data:', error);
        return throwError(() => error);
      })
    );
  }

  getFeedbackPrepop(entityID: string, programId: number): Observable<any> {
    const request = {
      entityID: entityID,
      programId: programId.toString(),
    };
    return this.http.post(`${environment.apiBaseUrl}/feedback/getFeedbackPrepop`, request);
  }
  
}
